import styled from 'styled-components';
import { fonts } from 'styles/fonts';

const slate50 = '#f8fafc';
const green500 = '#22C55E';
const red500 = '#ef4444';
const pageBackground = '#004a96';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TestEnvWarning = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40px;
  background-color: ${red500};
  color: white;
  font-size: 14px;
  line-height: 20px;
  position: fixed;
  margin-top: 0px;
  width: 100%;
`;

export const Main = styled.main`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100vw;
  background-color: ${pageBackground};
`;

type MainSectionProps = {
  testEnv?: boolean;
};

// MAIN SECTION
export const MainSection = styled.section<MainSectionProps>`
  display: flex;
  flex-direction: column;
  width: 370px;
  padding: 32px 40px;

  ${({ testEnv }) =>
    testEnv &&
    `
    padding-top: 64px;
  `}
`;

export const MainSectionFigure = styled.figure`
  max-width: 160px;
  width: 100%;
`;

export const MainSectionTitle = styled.h1`
  font-size: 26px;
  line-height: 32px;
  color: ${slate50};
  font-family: ${fonts.GilroyBold}, sans-serif;
  font-weight: 700;
  margin-top: 40px;
  margin-bottom: 40px;
`;

const Button = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 6px;
  font-size: 16px;
  height: 40px;
  font-family: ${fonts.GilroySemiBold}, sans-serif;
  padding: 8px 16px;
  cursor: pointer;
  transition: filter 0.3s ease-in-out;

  &:hover {
    filter: brightness(0.9);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SocialButton = styled(Button)`
  background-color: #ffffff;
  color: #000000;
  width: 100%;
  font-size: 14px;
`;

export const TextSeparator = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;

  & > div.line {
    height: 1px;
    flex-grow: 1;
    background-color: ${slate50};
    &.left {
      margin-right: 16px;
    }
    &.right {
      margin-left: 16px;
    }
  }

  & > span {
    color: ${slate50};
  }
`;

export const Instructions = styled.p`
  font-size: 14px;
  font-family: ${fonts.OpenSans}, sans-serif;
  font-weight: 500;
  width: 100%;
  line-height: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  color: ${slate50};

  & > a {
    color: ${green500};
    text-decoration: underline;
  }
`;

// FORM
export const FormContent = styled.div`
  label {
    color: ${slate50};
  }

  input {
    height: 40px;
    border-radius: 6px;
  }

  span {
    color: ${red500};
    margin-bottom: 4px;
  }
`;

export const ReCaptchaContainer = styled.div`
  transform: scale(0.96) translateX(-6px);
  margin-top: 20px;
  margin-bottom: 16px;
`;

export const SubmitButton = styled(Button)`
  background-color: ${green500};
  color: #ffffff;
  width: 100%;
`;

// ART SECTION
export const ArtSection = styled.section`
  flex-grow: 1;
  background-color: ${slate50};
`;

export const ArtSectionBackground = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;
